var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlideOnMobile',{staticClass:"u-marginTop"},[_c('div',{staticClass:"o-grid -equalHeight"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"s-newsCell o-grid__cell -c6 -c3@tabletPortrait -c2@desktopSmall"},[_c('CategoryCard',{attrs:{"category":category,"categorygroup":category.group}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }